import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../../api/axios";
import { ArrowLeft } from "lucide-react";
import { toast } from "react-toastify";
import { formatCurrencyCOP, formatDate } from "../../utils/format";

function ExitDetails() {
  const { id } = useParams();
  const [exit, setExit] = useState(null);

  useEffect(() => {
    api
      .get(`/exits/${id}`)
      .then((res) => setExit(res.data))
      .catch(() => toast.error("Error al obtener los detalles de la salida"));
  }, [id]);

  if (!exit) return <p className="p-6 text-gray-500">Cargando...</p>;

  return (
    <div className="bg-white p-6 rounded-xl shadow-md">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-3xl font-semibold text-gray-800">
          Detalles de Salida
        </h2>
        <Link
          to="/exits"
          className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-6"
        >
          <ArrowLeft size={20} />
          Volver a salidas
        </Link>
      </div>

      <div className="mb-6 flex gap-4">
        <div className="flex-1">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Fecha
          </label>
          <input
            type="text"
            value={formatDate(exit.date)}
            readOnly
            className="w-full px-3 py-2 border rounded-md bg-gray-100 text-gray-700"
          />
        </div>

        <div className="flex-1">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Cliente
          </label>
          <input
            type="text"
            value={exit.client?.name}
            readOnly
            className="w-full px-3 py-2 border rounded-md bg-gray-100 text-gray-700"
          />
        </div>

        <div className="flex-1">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Total salida
          </label>
          <input
            type="text"
            value={formatCurrencyCOP(exit.total_exit)}
            readOnly
            className="w-full px-3 py-2 border rounded-md bg-gray-100 text-gray-700"
          />
        </div>
      </div>

      <div className="overflow-x-auto rounded-xl shadow">
        <table className="min-w-full bg-white table-auto">
          <thead>
            <tr className="bg-gray-100 text-gray-700 text-center text-sm uppercase tracking-wider">
              <th className="px-6 py-3">Producto</th>
              <th className="px-6 py-3">Presentacion</th>
              <th className="px-6 py-3">Lote</th>
              <th className="px-6 py-3">Invima</th>
              <th className="px-6 py-3">Cantidad</th>
              <th className="px-6 py-3">Precio Unitario</th>
              <th className="px-6 py-3">Total</th>
            </tr>
          </thead>
          <tbody className="text-center">
            {exit.exit_details.map((detail, index) => (
              <tr
                key={detail.id}
                className={`border-t ${index % 2 === 0 ? "bg-white" : "bg-gray-50"
                  }`}
              >
                <td className="px-6 py-4">{detail.product?.name || "-"}</td>
                <td className="px-6 py-4">
                  {detail.variant?.presentation?.name || "-"}
                </td>
                <td className="px-6 py-4">{detail.variant?.batch_number || "-"}</td>
                <td className="px-6 py-4">
                  {detail.variant?.invima_code || "-"}
                </td>
                <td className="px-6 py-4">{detail.quantity}</td>
                <td className="px-6 py-4">{formatCurrencyCOP(detail.unit_price)}</td>
                <td className="px-6 py-4">{formatCurrencyCOP(detail.total_product)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ExitDetails;
